import { type ReactNode, Suspense } from "react";
import CircularProgress from "@mui/material/CircularProgress";

export const CustomSuspense = ({ children }: { children: ReactNode }) => {
	return (
		<Suspense
			fallback={
				<div
					style={{
						width: "100%",
						height: "calc(100vh - 64px)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress size={60} thickness={4} />
				</div>
			}
		>
			{children}
		</Suspense>
	);
};
